module.exports = __webpack_public_path__ + "img/success.5f4d117e.png";